import React, { ReactNode } from 'react';
import { styled } from "styled-components";

const StyledColumn = styled.div`
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
`;

interface ColumnProps {
    children: ReactNode;
  }

  const Column: React.FC<ColumnProps> = ({ children }) => {
    return (
      <StyledColumn>
        {children}
      </StyledColumn>
    );
  }

export default Column
